var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "detail-container" }, [
      _c("div", { staticClass: "detail-item" }, [
        _c("div", { staticClass: "detail-item-con" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("collectionCenter.compellation")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.realName)),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
          _c("div", [_vm._v("CPF")]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.cpf)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "detail-item" }, [
        _c("div", { staticClass: "detail-item-con" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("collectionCenter.codeStatus")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _c(
              "div",
              {
                style: {
                  color:
                    _vm.detailData.status === 1
                      ? "#0aa653"
                      : _vm.detailData.status === 2
                      ? "#dc2626"
                      : _vm.detailData.status === 3
                      ? "#909399"
                      : "#d97706",
                },
              },
              [
                _vm.detailData.status === 1
                  ? _c("div", [_vm._v(_vm._s(_vm.$t("userManage.effective")))])
                  : _vm._e(),
                _vm.detailData.status === 2
                  ? _c("div", [_vm._v(_vm._s(_vm.$t("userManage.expired")))])
                  : _vm._e(),
                _vm.detailData.status === 3
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.$t("collectionCenter.Disabled"))),
                    ])
                  : _vm._e(),
                _vm.detailData.status === 4
                  ? _c("div", [
                      _vm._v(_vm._s(_vm.$t("userManage.expiringSoon"))),
                    ])
                  : _vm._e(),
              ]
            ),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("userManage.LoginAccount")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.username)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "detail-item" }, [
        _c("div", { staticClass: "detail-item-con" }, [
          _c("div", [
            _vm._v(_vm._s(_vm.$t("collectionCenter.owningTransitCenter1"))),
          ]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.siteName)),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("home.position")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.positionName)),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "detail-item" }, [
        _c("div", { staticClass: "detail-item-con" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("customerManagements.genterTiem")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.validFrom)),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("seller.expirationTime")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.expireAt)),
          ]),
        ]),
      ]),
      _c("div", { staticStyle: { display: "flex" } }, [
        _c("div", { staticClass: "detail-item-con" }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.CreatePeople")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.createUserName)),
          ]),
        ]),
        _c("div", { staticStyle: { flex: "1", padding: "10px" } }, [
          _c("div", [_vm._v(_vm._s(_vm.$t("GlobalSetObj.CreationTime")))]),
          _c("div", { staticStyle: { "font-weight": "bold" } }, [
            _vm._v(_vm._s(_vm.detailData.createTime)),
          ]),
        ]),
      ]),
    ]),
    _c("div", { staticStyle: { "padding-top": "10px" } }, [
      _c(
        "div",
        { staticStyle: { "font-weight": "bold", "margin-bottom": "10px" } },
        [_vm._v(_vm._s(_vm.$t("userManage.AccountOperationRecord")))]
      ),
      _c(
        "div",
        { staticStyle: { "max-height": "200px", "overflow-y": "auto" } },
        _vm._l(_vm.tableData, function (item, index) {
          return _c(
            "div",
            {
              key: index,
              staticStyle: {
                "border-bottom": "1px solid #ddd",
                padding: "10px 0",
                display: "flex",
              },
            },
            [
              _c("div", { staticStyle: { "margin-right": "20px" } }, [
                _vm._v(_vm._s(item.operationTime)),
              ]),
              _c("div", [_vm._v(_vm._s(item.description))]),
            ]
          )
        }),
        0
      ),
      _c(
        "div",
        { staticClass: "page-size" },
        [
          _c("el-pagination", {
            staticStyle: { margin: "10px 0" },
            attrs: {
              layout: "total, sizes, prev, pager, next, jumper",
              "current-page": _vm.queryForm.pageNumber,
              "page-sizes": [10, 20, 50],
              "page-size": _vm.queryForm.pageSize,
              total: _vm.total,
              background: "",
              small: "",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryForm, "pageNumber", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryForm, "pageSize", $event)
              },
              "current-change": _vm.currentChange,
              "size-change": _vm.sizeChange,
            },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }